import * as React from 'react';

/**
 * DEPRECATED - use IconChevron
 * @param {*} props
 */
function SvgIconChevronLeft(props) {
    return (
        <svg width={50} height={50} viewBox='0 0 50 50' {...props}>
            <path d='M36.5 40.5L21.2 25.4l15.1-15-3.6-3.9-18.9 19 18.9 18.8z' />
        </svg>
    );
}

const MemoSvgIconChevronLeft = React.memo(SvgIconChevronLeft);
export default MemoSvgIconChevronLeft;
